export default "__VITE_ASSET__CoY63$q1__"